/*================ Shopify Common JS ================*/
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  } 
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt       = this.countryEl.options[this.countryEl.selectedIndex];
    var raw       = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

Shopify.formatMoney = function(cents, format = "") {
  if (typeof cents === "string") {
    cents = cents.replace(".", "");
  }
  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/, formatString = format || window.themeVariables.settings.moneyFormat;
  function defaultTo(value2, defaultValue) {
    return value2 == null || value2 !== value2 ? defaultValue : value2;
  }
  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultTo(precision, 2);
    thousands = defaultTo(thousands, ",");
    decimal = defaultTo(decimal, ".");
    if (isNaN(number) || number == null) {
      return 0;
    }
    number = (number / 100).toFixed(precision);
    let parts = number.split("."), dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands), centsAmount = parts[1] ? decimal + parts[1] : "";
    return dollarsAmount + centsAmount;
  }
  let value = "";
  switch (formatString.match(placeholderRegex)[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0);
      break;
    case "amount_with_space_separator":
      value = formatWithDelimiters(cents, 2, " ", ".");
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;
    case "amount_with_apostrophe_separator":
      value = formatWithDelimiters(cents, 2, "'", ".");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ",", ".");
      break;
    case "amount_no_decimals_with_space_separator":
      value = formatWithDelimiters(cents, 0, " ");
      break;
    case "amount_no_decimals_with_apostrophe_separator":
      value = formatWithDelimiters(cents, 0, "'");
      break;
  }
  if (formatString.indexOf("with_comma_separator") !== -1) {
    return formatString.replace(placeholderRegex, value);
  } else {
    return formatString.replace(placeholderRegex, value);
  }
}

/*================ Helper Functions ================*/
function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if(navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

function getCookie(name) {
  var v = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');
  return v ? v[2] : null;
}

function setCookie(name, value, days) {
  var d = new Date;
  d.setTime(d.getTime() + 24*60*60*1000*days);
  document.cookie = name + "=" + value + ";path=/;expires=" + d.toGMTString();
}

function slideUp(target, duration = 500) {
  target.style.transitionProperty = 'height, margin, padding';
  target.style.transitionDuration = duration + 'ms';
  target.style.boxSizing = 'border-box';
  target.style.height = target.offsetHeight + 'px';
  target.offsetHeight;
  target.style.overflow = 'hidden';
  target.style.height = 0;
  target.style.paddingTop = 0;
  target.style.paddingBottom = 0;
  target.style.marginTop = 0;
  target.style.marginBottom = 0;
  window.setTimeout( () => {
        target.style.display = 'none';
        target.style.removeProperty('height');
        target.style.removeProperty('padding-top');
        target.style.removeProperty('padding-bottom');
        target.style.removeProperty('margin-top');
        target.style.removeProperty('margin-bottom');
        target.style.removeProperty('overflow');
        target.style.removeProperty('transition-duration');
        target.style.removeProperty('transition-property');
        //alert("!");
  }, duration);
}

function slideDown(target, duration = 500) {
  target.style.removeProperty('display');
  let display = window.getComputedStyle(target).display;
  if (display === 'none') display = 'block';
  target.style.display = display;
  let height = target.offsetHeight;
  target.style.overflow = 'hidden';
  target.style.height = 0;
  target.style.paddingTop = 0;
  target.style.paddingBottom = 0;
  target.style.marginTop = 0;
  target.style.marginBottom = 0;
  target.offsetHeight;
  target.style.boxSizing = 'border-box';
  target.style.transitionProperty = "height, margin, padding";
  target.style.transitionDuration = duration + 'ms';
  target.style.height = height + 'px';
  target.style.removeProperty('padding-top');
  target.style.removeProperty('padding-bottom');
  target.style.removeProperty('margin-top');
  target.style.removeProperty('margin-bottom');
  window.setTimeout( () => {
    target.style.removeProperty('height');
    target.style.removeProperty('overflow');
    target.style.removeProperty('transition-duration');
    target.style.removeProperty('transition-property');
  }, duration);
}

function slideToggle(target, duration = 500) {
  if (window.getComputedStyle(target).display === 'none') {
    return slideDown(target, duration);
  } else {
    return slideUp(target, duration);
  }
}

function fadeIn(target, duration = 500) {
  target.style.display = '';
  target.style.opacity = 0;
  var last = +new Date();
  var tick = function() {
    target.style.opacity = +target.style.opacity + (new Date() - last) / duration;
    last = +new Date();
    if (+target.style.opacity < 1) {
      (window.requestAnimationFrame && requestAnimationFrame(tick)) || setTimeout(tick, 16);
    }
  };
  tick();
}

function fadeOut(target, duration = 500) {
  target.style.display = '';
  target.style.opacity = 1;
  let last = +new Date();
  let tick = function() {
    target.style.opacity = Number(+target.style.opacity - (new Date() - last) / duration).toFixed(4);
    last = +new Date();
    if (-target.style.opacity <= 0) {
      (window.requestAnimationFrame && requestAnimationFrame(tick)) || setTimeout(tick, 16);
    } else{
        target.style.opacity = 0;
    }
  };
  tick();
}

function getSectionInnerHTML(html, selector) {
  return new DOMParser()
    .parseFromString(html, 'text/html')
    .querySelector(selector).innerHTML;
}

function atcGetSectionsToRender() {
  return [
    {
      id: 'cart-drawer__content',
      section: document.getElementById('cart-drawer__content').dataset.id,
      selector: '.cart-drawer__content',
    },
    {
      id: 'cart-icon-bubble',
      section: 'cart-icon-bubble',
      selector: '.shopify-section'
    }
  ];
}

const atcButtons = document.querySelectorAll('.js-add-to-cart');
document.body.addEventListener('click', event => {
	if (event.target.classList.contains('js-add-to-cart')) {
    event.preventDefault();

    const id = Number(event.target.dataset.id);

    const body = JSON.stringify({
      items: [{
        id: id,
        quantity: 1
      }],
      sections: atcGetSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });

    fetch(`${routes.cart_add_url}`, { ...fetchConfig('javascript'), body })
      .then((response) => response.json())
      .then((parsedState) => {
        atcGetSectionsToRender().forEach((section => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);

          elementToReplace.innerHTML =
            getSectionInnerHTML(parsedState.sections[section.section], section.selector);

        }));
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        document.querySelector('cart-drawer').open();
      });
  }
});

const serializeForm = form => {
  const obj = {};
  const formData = new FormData(form);
  for (const key of formData.keys()) {
    obj[key] = formData.get(key);
  }
  return JSON.stringify(obj);
};

Shopify.money_format = "${{amount}}";
Shopify.formatMoney = function(cents, format) {
  if (typeof cents == 'string') { cents = cents.replace('.',''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format);

  function defaultOption(opt, def) {
     return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal   = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) { return 0; }

    number = (number/100.0).toFixed(precision);

    var parts   = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents   = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  switch(formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

// Scroll into view
document.querySelectorAll('a').forEach(link => {
  const linkHref = link.getAttribute('href');

  if (linkHref && linkHref.includes('#') && linkHref != '#credits' && linkHref != '#') {
    link.addEventListener('click', event => {
      event.preventDefault();
      const el = document.querySelector(linkHref);
      
      if (el) {
        const fromTop = (el.getBoundingClientRect().top + window.pageYOffset) - (document.querySelector('.outer-header-wrapper').offsetHeight + 1);
  
        window.scrollTo({
          top: fromTop,
          behavior: 'smooth'
        });
      }
    });
  }
});


/*================ Initialize ================*/
// Micromodal
MicroModal.init({
  openClass: 'is-open',
  disableScroll: true,
  disableFocus: true,
  awaitOpenAnimation: true,
  awaitCloseAnimation: true
});

// GSAP
gsap.registerPlugin(ScrollTrigger);

// Simple Parallax
var images = document.querySelectorAll('.parallax img');
new simpleParallax(images, {
  scale: 1.2
});

/*================ Animations ================*/
// Fade In
gsap.utils
  .toArray('.fade-in')
  .forEach(elem => {
    const duration = Number(elem.dataset.duration);
    const delay = Number(elem.dataset.delay);

    gsap.to(elem, { 
      opacity: 1,
      duration: duration || .65,
      delay: delay || 0,
      ease: 'linear',
      scrollTrigger: {
        trigger: elem,
        start: "top 92%"
      }
    });
  });

/*================ Components ================*/
var MenuDrawer = class extends HTMLElement {
  constructor() {
    super();

    this.drawer = this.drawer = document.getElementById('menu-drawer');
    this.openButtons = document.querySelectorAll('.js-open-menu');
    this.closeButtons = document.querySelectorAll('.js-close-menu');
    this.menuButtons = document.querySelectorAll('.menu-drawer__menu-button');
    this.closeMenuButtons = document.querySelectorAll('.js-close-secondary-menus');
    this.pageOverlayElement = document.querySelector('.page-overlay');
    
    this.drawer.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.closeMenuDrawer());
    this.bindEvents();
    this.initSlider();
  }

  bindEvents() {
    this.openButtons.forEach(openBtn => openBtn.addEventListener('click', this.openMenuDrawer.bind(this)));
    this.closeButtons.forEach(closeBtn => closeBtn.addEventListener('click', this.closeMenuDrawer.bind(this)));
    this.menuButtons.forEach(menuBtn => menuBtn.addEventListener('click', this.toggleMenuButtons.bind(this)));
    this.closeMenuButtons.forEach(closeBtn => closeBtn.addEventListener('click', this.closeSecondaryMenu.bind(this)));
    this.onBodyClick = this.handleBodyClick.bind(this);
  }

  openMenuDrawer() {
    this.drawer.setAttribute('aria-hidden', false);
    this.drawer.setAttribute('aria-expanded', true);

    this.pageOverlayElement.classList.add('is-visible');
    document.body.addEventListener('click', this.onBodyClick);
    document.body.classList.add('scroll-lock');
  }

  closeMenuDrawer() {
    this.drawer.setAttribute('aria-hidden', true);
    this.drawer.removeAttribute('aria-expanded', true);

    this.pageOverlayElement.classList.remove('is-visible');
    document.body.removeEventListener('click', this.onBodyClick);
    document.body.classList.remove('scroll-lock');

    setTimeout(() => {
      this.closeSecondaryMenu();
    }, 400);
  }

  toggleMenuButtons() {
    const secondaryMenu = event.target.nextElementSibling;
    const content = document.querySelector('.menu-drawer__content');
    
    if (secondaryMenu.classList.contains('is-open')) {
      secondaryMenu.classList.remove('is-open');
      content.classList.remove('scroll-lock');
    } else {
      secondaryMenu.classList.add('is-open');
      content.classList.add('scroll-lock');
    }
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target.classList.contains('page-overlay')) {
      this.closeMenuDrawer();
      this.pageOverlayElement.classList.remove('is-visible');
    }
  }

  closeSecondaryMenu() {
    const menu = document.querySelector('.menu-drawer__secondary-menu.is-open');
    const content = document.querySelector('.menu-drawer__content');
    
    if (menu) {
      menu.classList.remove('is-open');
      content.classList.remove('scroll-lock');
    }
  }

  initSlider() {
    const collectionSlider = new Swiper('.menu-drawer__collection-slider', {
      slidesPerView: 1.7,
      loop: true,
      spaceBetween: 10,
    });
  }
}

customElements.define('menu-drawer', MenuDrawer);

var QuantityInput = class extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true })

    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define('quantity-input', QuantityInput);

var VariantRadios = class extends HTMLElement {
  constructor() {
    super();

    this.hasSizeVariant = this.dataset.size;
    this.optionsCount = Number(this.dataset.options);
    this.fieldsets = Array.from(this.querySelectorAll('fieldset'));

    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange() {

    this.updateOptions();
    // Check if amount of fieldsets with selected values == total fieldsets
    // If not, do not follow through, but update images
    if (this.options.length != this.optionsCount) {
      this.updateImageWithoutSize(event.target);
      return;
    }

    this.updateMasterId();
    this.removeErrorMessage();
    this.updateActiveVariantText(event);

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      console.log(this.currentVariant)
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateOptions() {
    this.options = this.fieldsets.map((fieldset) => {
      const selectedRadio = Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked);
      if (selectedRadio) {
        return selectedRadio.value;
      }
    });

    this.options = this.options.filter(val => { return val !== undefined; });
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;
    const newMedia = document.querySelector(
      `[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`
    );

    if (!newMedia) return;

    window.productSlider.slideToLoop(Number(newMedia.dataset.index));
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updateActiveVariantText(event) {
    const isColor = event.target.classList.contains('product-form__color-swatch-input');
    
    if (isColor) {
      let value = event.target.closest('input:checked').value;
      const activeTextEl = this.querySelector('.product-form__active-color');
      activeTextEl.innerHTML = value;
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const id = `price-${this.dataset.section}`;
        const id2 = `price-${this.dataset.section}-2`;
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(id);
        const destination2 = document.getElementById(id2);
        const source = html.getElementById(id);
        const variantPickerDestination = document.querySelector('.product-form__input-labels');
        const variantPickerSource = html.querySelector('.product-form__input-labels');

        if (source && destination) {
          destination.innerHTML = source.innerHTML;

          if (destination2) {
            destination2.innerHTML = source.innerHTML;
          }
        }

        if (variantPickerSource && variantPickerDestination) variantPickerDestination.innerHTML = variantPickerSource.innerHTML;

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('visibility-hidden');
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);

        this.updateInventory(html);
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');

    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }

  updateImageWithoutSize(target) {
    const colorSwatches = this.querySelector('.product-form__color-swatches');
    const closestVariant = target.dataset.closest;

    if (colorSwatches) {
      const activeColor = colorSwatches.querySelector('input:checked').dataset.image;
      if (!activeColor) return;

      // Slide to
      window.productSlider.slideToLoop(Number(activeColor) - 1);

      // Change text
      const activeColorText = colorSwatches.querySelector('input:checked').value;
      const activeTextEl = this.querySelector('.product-form__active-color');
      activeTextEl.innerHTML = activeColorText;
    }

    fetch(`${this.dataset.url}?variant=${closestVariant}&section_id=${this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const variantPickerDestination = document.querySelector('.product-form__input-labels');
        const variantPickerSource = html.querySelector('.product-form__input-labels');

        if (variantPickerSource && variantPickerDestination) variantPickerDestination.innerHTML = variantPickerSource.innerHTML;
        this.fieldsets.map((fieldset) => {
          const selectedRadio = Array.from(fieldset.querySelectorAll('input:not(.product-form__color-swatch-input)')).find((radio) => radio.checked);
          if (selectedRadio) {
            selectedRadio.checked = false;
          }
        });
      });
  }

  updateInventory(html) {
    const radiosContainer = html.querySelector('variant-radios');
    if (!radiosContainer) return;
    
    const inventory = Number(radiosContainer.dataset.i);
    console.log(inventory)
    const inventoryContainers = document.querySelectorAll('.product__inventory');

    if (inventoryContainers) {
      inventoryContainers.forEach(container => {
        if (inventory == 2) {
          const html = '<p class="product__inventory-text caption">Only two left</p>';
          container.innerHTML = html;
        } else if (inventory == 1) {
          const html = '<p class="product__inventory-text caption">Only one left</p>';
          container.innerHTML = html;
        } else {
          container.innerHTML = '';
        }
      });
    }
  }
}

customElements.define('variant-radios', VariantRadios);

class ProductCard extends HTMLElement {
  constructor() {
    super();
    this.swatches = this.querySelectorAll('.product-card__swatch');
    this.cardImage = this.querySelector('.product-card__image .initial-image img');
    this.links = this.querySelectorAll('.product-card__link');
    this.dataLinks = this.querySelectorAll('[data-product-url]');
    this.card = this.querySelector('.product-card__image');

    this.handleSwatchClick = (swatch, event) => {
      event.preventDefault();
      this.onSwatchClick(swatch);
    };

    this.swatches.forEach(swatch => {
      swatch.addEventListener('click', this.handleSwatchClick.bind(this, swatch));
    });
  }

  onSwatchClick(swatch, event) {
    if (!swatch.classList.contains('active')) {
      this.updateActiveSwatch(swatch);
      this.updateImage(swatch);
      this.updateLinks(swatch);
      this.updatePrice(swatch);
    }
  }

  updateActiveSwatch(swatch) {
    this.swatches.forEach(swatch => {
      swatch.classList.remove('active');
    });

    swatch.classList.add('active');
  }

  updateImage(swatch) {
    const image = swatch.dataset.image;
    
    if (image) this.cardImage.setAttribute('src', image);
  }

  updateLinks(swatch) {
    const url = swatch.dataset.url;

    this.links.forEach(link => {
      link.setAttribute('href', url);
    });

    // this.dataLinks.forEach(link => {
    //   link.setAttribute('data-product-url', url);
    // });
  }

  updatePrice(swatch) {
    const priceContainer = this.querySelector('.product-card__price');
    const price = swatch.dataset.price;
    const comparePrice = swatch.dataset.comparePrice;

    if (comparePrice > price) {
      priceContainer.innerHTML = `<span class="old-price">${Shopify.formatMoney(comparePrice)}</span><span class="new-price">${Shopify.formatMoney(price)}</span>`
    } else {
      priceContainer.innerHTML = Shopify.formatMoney(price);
    }
  }
}

customElements.define('product-card', ProductCard);


class QuickView extends HTMLElement {
  constructor() {
    super();

    this.quickView = this;
    this.quickViewContent = this.querySelector('.quick-view__content');

    document.body.addEventListener('click', event => {
      if (event.target.closest('.product-card__quick-view')) {
        this.open(event.target.closest('.product-card__quick-view'));
      }
    });
    this.buttons = document.querySelectorAll('.product-card__quick-view');
    // this.buttons.forEach(button => {
    //   button.addEventListener('click', this.open.bind(this));
    // });

    this.closeButtons = this.querySelectorAll('.quick-view__close');
    this.closeButtons.forEach(button => {
      button.addEventListener('click', this.close.bind(this));
    });
    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
  }

  close() {
    this.quickView.setAttribute('aria-hidden', true);
    setTimeout(() => {
      this.quickViewContent.innerHTML = '';
    }, 350);
  }

  open(event) {
    const opener = event.currentTarget || event;
    console.log(opener)
    opener.classList.add('loading');
    opener.querySelector('.loading-overlay').classList.remove('hidden');

    fetch(opener.dataset.productUrl)
      .then((response) => response.text())
      .then((responseText) => {
        const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
        this.productElement = responseHTML.querySelector('#product');
        this.quickViewContent.innerHTML = this.productElement.innerHTML;

        const productThumbsSlider = new Swiper('.quick-view .product__thumbnail-list', {
          slidesPerView: 'auto',
          loop: false,
          spaceBetween: 0,
          direction: 'vertical',
          mousewheelControl: true,
          freeMode: true,
          navigation: {
            nextEl: '.product__thumbnail-wrapper .swiper-button-next'
          }
        });
      
        const productSlider = new Swiper('.quick-view .product__media-list', {
          slidesPerView: 1.05,
          loop: false,
          spaceBetween: 13,
          thumbs: {
            swiper: productThumbsSlider
          },
          pagination: {
            el: '.product__media-pagination',
            clickable: true
          },
          breakpoints: {
            851: {
              slidesPerView: 1,
              spaceBetween: 20,
              loop: true
            }
          }
        }); 

        window.productSlider = productSlider;

        setTimeout(() => {
          this.quickView.setAttribute('aria-hidden', false);
        }, 150);

        this.preventVariantURLSwitching();
      })
      .finally(() => {
        this.querySelector('.product-form__submit').addEventListener('click', event => {
          if (!event.target.disabled) {
            this.close();
          }
        });
        
        opener.classList.remove('loading');
        opener.querySelector('.loading-overlay').classList.add('hidden');
      });
  }

  setInnerHTML(element, html) {
    element.innerHTML = html;

    // Reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
    element.querySelectorAll('script').forEach(oldScriptTag => {
      const newScriptTag = document.createElement('script');
      Array.from(oldScriptTag.attributes).forEach(attribute => {
        newScriptTag.setAttribute(attribute.name, attribute.value)
      });
      newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
      oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
    });
  }

  preventVariantURLSwitching() {
    this.quickViewContent.querySelector('variant-radios,variant-selects').setAttribute('data-update-url', 'false');
  }

  removeDOMElements() {
    const pickupAvailability = this.productElement.querySelector('pickup-availability');
    if (pickupAvailability) pickupAvailability.remove();

    const productModal = this.productElement.querySelector('product-modal');
    if (productModal) productModal.remove();
  }

  preventDuplicatedIDs() {
    const sectionId = this.productElement.dataset.section;
    this.productElement.innerHTML = this.productElement.innerHTML.replaceAll(sectionId, `quickadd-${ sectionId }`);
    this.productElement.querySelectorAll('variant-selects, variant-radios').forEach((variantSelect) => {
      variantSelect.dataset.originalSection = sectionId;
    });
  }

  removeGalleryListSemantic() {
    const galleryList = this.modalContent.querySelector('[id^="Slider-Gallery"]');
    if (!galleryList) return;

    galleryList.setAttribute('role', 'presentation');
    galleryList.querySelectorAll('[id^="Slide-"]').forEach(li => li.setAttribute('role', 'presentation'));
  }
}

customElements.define('quick-view', QuickView);

var DropdownItem = class extends HTMLElement {
  constructor() {
    super();

    this.parent = this.querySelector('.dropdown');
    this.header = this.querySelector('.dropdown-header');
    this.content = this.querySelector('.dropdown-content');

    this.header.addEventListener('click', this.onDropdownClick.bind(this));
  }

  onDropdownClick() {
    if (this.parent.classList.contains('active')) {
      this.parent.classList.remove('active');
      slideUp(this.content, 300);
    } else {
      this.parent.classList.add('active');
      slideDown(this.content, 300);
    }
  }
}

customElements.define('dropdown-item', DropdownItem);

class GiftForm extends HTMLElement {
  constructor() {
    super();

    this.checkbox = this.querySelector('input[type="checkbox"]');
    this.message = this.querySelector('textarea');
    this.submit = this.querySelector('.gift-form__add');
    this.inputWrapper = this.querySelector('.gift-form__input-wrapper');

    this.giftId = Number(this.dataset.id);

    // Cart drawer only
    this.giftSlideout = this.closest('gift-slideout');
    this.cartDrawer = this.closest('cart-drawer');

    // Cart page only
    this.cart = this.closest('cart-items');
    this.edit = this.querySelector('.cart__message-edit');

    this.setListeners();
  }

  setListeners() {
    this.checkbox.addEventListener('change', this.onCheck.bind(this));
    this.message.addEventListener('input', this.onMessageChange.bind(this));
    this.submit.addEventListener('click', this.onSubmit.bind(this));
    this.addEventListener('click', event => {
      if (event.target.closest('.cart__message-edit')) {
        event.preventDefault();
        this.onEdit();
      }
    });
  }

  onCheck() {
    this.toggleForm();
  }
  
  toggleForm() {
    // if (event.target.checked) {
    //   this.inputWrapper.classList.remove('disabled');
    // } else {
    //   this.inputWrapper.classList.add('disabled');
    //   if (this.cart) {
    //     this.cart.removeNote(true);
    //   }
    // }
  }

  onMessageChange() {
    const characterCountEl = this.querySelector('.gift-form__input-character-count');
    const characterCount = 250 - this.message.value.length;

    characterCountEl.innerHTML = characterCount + ` character${(characterCount != 1 ? 's' : '')} left`;
  }

  onEdit() {
    event.preventDefault();

    this.querySelector('.cart__message').classList.add('disabled');
    this.inputWrapper.classList.remove('disabled');
  }

  onSubmit() {
    event.preventDefault();

    const addGiftBox = this.querySelector('#add-gift-slideout').checked;
    const route = addGiftBox ? routes.cart_add_url : routes.cart_update_url;
    const messageTextContainer = this.querySelector('.cart__message');
    const newMessage = this.message.value;
    let body = '';

    if (addGiftBox) {
      body = JSON.stringify({
        items: [{
          id: this.giftId,
          quantity: 1
        }],
        note: newMessage
      });
    } else {
      body = JSON.stringify({
        note: newMessage
      });
    }

    fetch(`${route}`, { ...fetchConfig('javascript'), body })
      .then((response) => response.json())
      .then((responseText) => {

        if (this.cartDrawer) {
          this.cartDrawer.rerender();
          this.giftSlideout.close();
        } else {
          this.cart.rerender();
          this.inputWrapper.classList.add('disabled');
          if (messageTextContainer) {
            messageTextContainer.classList.remove('disabled');
            messageTextContainer.querySelector('.cart__message-text').innerHTML = newMessage;
          } else {
            const elContent = `
              <div class="cart__message">
                <p class="cart__message-text body-5">${ newMessage }</p>
                <button class="cart__message-edit caption">Edit Message</button>
              </div>
            `;
            this.querySelector('.cart__message-wrapper').innerHTML = elContent;
          }
        }

      })
      .catch((e) => {
        console.error(e);
      });

  }
}

customElements.define('gift-form', GiftForm);

var ProductSlider = class extends HTMLElement {
  constructor() {
    super();

    this.navigationItems = this.querySelectorAll('.product-slider__navigation-item');
    this.navigationItems.forEach(item => {
      item.addEventListener('click', this.handleNavClick.bind(this));
    });
  }

  handleNavClick() {
    const el = event.target;
    const collection = el.dataset.collection;

    if (!el.classList.contains('active')) {
      this.querySelector('.product-slider__navigation-item.active').classList.remove('active');
      el.classList.add('active');

      this.querySelector('.product-slider__arrows.active').classList.remove('active');
      this.querySelector(`.product-slider__arrows[data-collection="${collection}"]`).classList.add('active'); 

      this.querySelector('.product-slider__collection.active').classList.remove('active');
      this.querySelector(`.product-slider__collection[data-collection="${collection}"]`).classList.add('active'); 
    }
  }
}

customElements.define('product-slider', ProductSlider);